// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".user-body{flex:1;padding:15px}", "",{"version":3,"sources":["webpack://./resources/assets/js/components/views/Users/Create.vue"],"names":[],"mappings":"AAEI,WACI,MAAA,CACA,YADR","sourcesContent":["\n\n    .user-body {\n        flex: 1;\n        padding: 15px;\n    }\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
